import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { JobCancellationButtonComponent } from './job-cancellation-button.component';

@NgModule({
  imports: [CommonModule, MatProgressSpinnerModule, FontAwesomeModule, MatLegacyButtonModule],
  exports: [JobCancellationButtonComponent],
  declarations: [JobCancellationButtonComponent],
})
export class JobCancellationButtonModule {}
